// Public identifiers of the courageMFG API app registration (PLANMXL tenant). Not secrets.
export const config = {
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID ?? "fb815146-955b-45ae-8753-0e9c0ae6dffd",
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? "01c34000-61ac-4ca9-afd6-27c5d26a1066",
  // "dev" skips Entra and sends an x-user header; pairs with AUTH_MODE=dev on the API. Set VITE_AUTH_MODE=dev in .env.local.
  authMode: (import.meta.env.VITE_AUTH_MODE ?? "entra") as "entra" | "dev",
};

export const apiScope = `api://${config.clientId}/access_as_user`;

// Business Central deep links. Tenant defaults to the sign-in tenant; environment and company can be set
// per user on the Integrations page (kept in this browser only).
export type BcTarget = { tenant: string; environment: string; company: string };
const read = (k: string) => { try { return localStorage.getItem(k) ?? ""; } catch { return ""; } };
export const bcTarget = (): BcTarget => ({
  tenant: read("bc.tenant") || config.tenantId,
  environment: read("bc.environment") || "Production",
  company: read("bc.company"),
});
export const saveBcTarget = (t: Partial<BcTarget>) => {
  try { for (const [k, v] of Object.entries(t)) v ? localStorage.setItem(`bc.${k}`, v) : localStorage.removeItem(`bc.${k}`); } catch {}
};
/** A Business Central report, opened to its request page. */
export const bcReportUrl = (report: number, t: BcTarget = bcTarget()) =>
  `https://businesscentral.dynamics.com/${encodeURIComponent(t.tenant)}/${encodeURIComponent(t.environment)}/?${t.company ? `company=${encodeURIComponent(t.company)}&` : ""}report=${report}`;
export const bcUrl = (page: number, t: BcTarget = bcTarget()) =>
  `https://businesscentral.dynamics.com/${encodeURIComponent(t.tenant)}/${encodeURIComponent(t.environment)}/?${t.company ? `company=${encodeURIComponent(t.company)}&` : ""}page=${page}`;
